export const UPDATE_TAG_REQUEST = 'UPDATE_TAG_REQUEST';

export const updateTagRequest = ( id: string, updateData: {} ) => ({
    type: UPDATE_TAG_REQUEST,
    payload: { id, updateData }
});
